export default {
  input_placeholder: "Need to do another thing? Put it here",
}
